import React, { ChangeEvent, FunctionComponent } from 'react'
import { UseFormSetValue } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '../../../../App/Hooks/reduxHooks'
import { Person } from '../../../../App/store/features/person/IPerson'
import { calendarSettingsSelector } from '../../../store/calendarSlice'

interface IProps {
  persons: Person[]
  setValue: UseFormSetValue<any>
}

export const UserPicker: FunctionComponent<IProps> = ({
  persons,
  setValue,
}) => {
  const { t } = useTranslation()
  const updatePerson = (e: ChangeEvent<HTMLSelectElement>) => {
    setValue('personUuid', e.target.value)
  }

  const { inActivePersonIds } = useAppSelector(calendarSettingsSelector)

  if (typeof inActivePersonIds === 'undefined') {
    return null
  }

  const PersonElementMap: JSX.Element[] = persons.map(person => (
    <LabelSelectOption
      key={person.id}
      value={person.personUuid}
      disabled={inActivePersonIds.includes(person.id)}>
      {person.firstName}
    </LabelSelectOption>
  ))

  return (
    <LabelSelect
      fieldLabel={t('Person')}
      fieldColor="#005cd9"
      leadingIcon="user"
      optionsArray={PersonElementMap}
      onChange={updatePerson}
      customWidth="400px"
    />
  )
}
